module.exports = __webpack_public_path__ + "img/DNI-ALFY-Dorso.6eebc75b.jpg";